export type JsonWebTokenType = {
  at: string;
  rt: string;
}

const TokenManager = {
  getToken(): JsonWebTokenType {
    const at = localStorage.getItem('at') || '';
    const rt = localStorage.getItem('rt') || '';
    return { at, rt };
  },

  setToken({ at, rt }: JsonWebTokenType) {
    if (at && rt) {
      localStorage.setItem('at', at);
      localStorage.setItem('rt', rt);
    }
  },

  removeToken() {
    localStorage.removeItem('at');
    localStorage.removeItem('rt');
  },
};

export default TokenManager;
